import { render, staticRenderFns } from "./ProductSelectQuantity.vue?vue&type=template&id=28faeeaa&scoped=true&"
import script from "./ProductSelectQuantity.vue?vue&type=script&lang=js&"
export * from "./ProductSelectQuantity.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelectQuantity.vue?vue&type=style&index=0&id=28faeeaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28faeeaa",
  null
  
)

export default component.exports